<template>
  <v-dialog v-model="deleteDialog.show" scrollable :max-width="$spec.dialog_standard_max_width">
    <v-card>
      <v-card-title class="headline">
        <v-spacer></v-spacer>

        <v-btn text icon color="grey" large @click="deleteDialog.show=flase">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="d-flex flex-column">
          <v-icon class="text-center" x-large color="red">mdi-alert</v-icon>
          <span class="text-center headline mt-2 black--text" v-text="`刪除${deleteDialog.title}`"></span>
          <span class="mt-5 subtitle-1 black--text">警告：這個刪除動作無法復原</span>
          <v-checkbox
            class="subtitle-1 mt-0"
            color="primary"
            v-model="deleteDialog.checkbox"
            :label="`我了解刪除${deleteDialog.target}後將無法復原`"
          ></v-checkbox>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red"
          :disabled="!deleteDialog.checkbox"
          text
          @click="remove()"
          v-text="`刪除${deleteDialog.target}`"
          :loading="deleteDialog.loading"
        ></v-btn>
        <v-btn
          color="grey"
          text
          @click="deleteDialog.show = false"
          v-text="`保留${deleteDialog.target}`"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    deleteDialog: {
      show: false,
      checkbox: false,
      target: "",
      title: "",
      loading: false
    },
    opt: "",
    reportId: "",
    petIds: [],
    phones: [],
    clinics: []
  }),
  methods: {
    showForDeleteReport(reportId, reportDate) {
      this.opt = "deleteReport";
      this.reportId = reportId;
      this.deleteDialog.target = "報告";
      this.deleteDialog.title = `${reportDate}報告`;
      this.deleteDialog.checkbox = false;
      this.deleteDialog.loading = false;
      this.deleteDialog.show = true;
    },
    showForDeletePet(pets) {
      this.opt = "deletePet";
      console.log("delete pets:" + JSON.stringify(pets));
      this.petIds = [];
      let thisVm = this;
      let names = [];
      pets.forEach(pet => {
        thisVm.petIds.push(pet._id);
        names.push(pet.name);
      });

      this.deleteDialog.target = "寵物";
      this.deleteDialog.title = `寵物 ${names}`;
      this.deleteDialog.checkbox = false;
      this.deleteDialog.loading = false;
      this.deleteDialog.show = true;
    },
    showForDeleteUser(users) {
      this.opt = "deleteUser";
      console.log("delete user:" + JSON.stringify(users));
      this.phones = [];
      let thisVm = this;
      let names = [];
      users.forEach(user => {
        thisVm.phones.push(user.phone);
        names.push(user.name);
      });

      this.deleteDialog.target = "使用者";
      this.deleteDialog.title = `使用者 ${names}`;
      this.deleteDialog.checkbox = false;
      this.deleteDialog.loading = false;
      this.deleteDialog.show = true;
      console.log("this.phones:" + this.phones);
    },
    showForDeleteClinic(clinics) {
      this.opt = "deleteClinic";
      console.log("delete clinic:" + JSON.stringify(clinics));
      this.clinics = clinics;

      let names = [];
      clinics.forEach(clinic => {
        names.push(clinic.clinic);
      });
      this.deleteDialog.target = "診所";
      this.deleteDialog.title = `診所 ${names}`;
      this.deleteDialog.checkbox = false;
      this.deleteDialog.loading = false;
      this.deleteDialog.show = true;
    },

    async remove() {
      this.deleteDialog.loading = true;
      switch (this.opt) {
        case "deleteReport":
          console.log("deleteReport");
          await this.$ajax.delete(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/reports/${
              this.reportId
            }`
          );
          break;
        case "deletePet":
          await this.$ajax.post(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/delete/pets`,
            { id: this.petIds }
          );
          break;
        case "deleteUser":
          await this.$ajax.post(
            `${this.$config.apiUrl}/${this.$my.getClinic()}/delete/users`,
            { phone: this.phones }
          );
          break;
        case "deleteClinic":
          for (let clinic of this.clinics) {
            await this.$ajax.delete(
              `${this.$config.apiUrl}/clinicData/${clinic.clinic}`
            );
            await this.$ajax.post(
              `${this.$config.apiUrl}/${clinic.clinic}/delete/users`,
              { phone: [clinic.phone] }
            );
          }
          break;
      }
      this.deleteDialog.loading = false;
      this.$emit("done");
      this.deleteDialog.show = false;
    }
  }
};
</script>
